import { Injectable, OnInit } from "@angular/core";
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';
import { Claim, IdentityUser, Policies } from './identity.models';

@Injectable()
export class IdentityService implements OnInit
{
	private token: string;
	private user: IdentityUser;

	constructor(private jwtHelper: JwtHelperService)
	{
	}

	// init
	ngOnInit()
	{
		// get access token
		this.token = AuthService.getAccessToken();
	}

	// get logged identity user
	getUser(): IdentityUser
	{
		// setting user from token
		if (true)
		{
			// decoding token payload
			const tokenPayload = this.jwtHelper.decodeToken(this.token);

			if (tokenPayload)
			{
				// loading user info
				this.user = new IdentityUser();
				this.user.id = tokenPayload[Claim.NameIdentifier];
				this.user.username = tokenPayload[Claim.Name];
				this.user.firstName = tokenPayload[Claim.GivenName];
				this.user.lastName = tokenPayload[Claim.Surname];
				this.user.email = tokenPayload[Claim.EmailAddress];
				this.user.sysAdmin = tokenPayload[Claim.SysAdmin] === 'false' ? false : true;
				this.user.language = tokenPayload[Claim.Language];
				this.user.policies = JSON.parse(tokenPayload[Claim.Policies]);
				this.user.roles = JSON.parse(tokenPayload[Claim.Roles]);
				this.user.isActive = tokenPayload[Claim.IsActive] === 'false' ? false : true;
				this.user.customerEquipePrivacyConsent = tokenPayload[Claim.CustomerEquipePrivacyConsent] === 'false' ? false : true;
			}
			else
			{
				this.user = null;
			}
		}

		return this.user;
	}

	// verify current user has policy
	hasPolicy(alias: Policies): boolean
	{
		// get current user
		const user: IdentityUser = this.getUser();

		if (!user.sysAdmin)
			return user.policies.indexOf(Policies[alias].toString()) >= 0;
		else
			return true;
	}

	// verify roles
	getPWARole(): string {
		// get current user
		const user: IdentityUser = this.getUser();

		return user.roles[0];
	}
}